<template>
  <div class="schoolPane">
    <div class="pane SchoolList">
      <h3>
        <span>{{ areaValue }}</span
        >学校列表 <i>{{ shcoolnum }}</i
        >个
        <div class="info2" @click="openInfo">
          <img src="../../public/images/info2.png" alt="" />
          <div class="circle1"></div>
          <div class="circle2"></div>
          <div class="circle3"></div>
        </div>
      </h3>
      <div class="cont">
        <el-table
          v-loading="loading"
          :data="tableData"
          stripe
          height="100%"
          border
          style="width: 100%"
          @row-click="showSchoolHouse"
        >
          <el-table-column prop="id" label="序号" width="48" align="center">
          </el-table-column>
          <el-table-column prop="properties.NAME" label="学校名称">
          </el-table-column>
          <el-table-column
            prop="properties.TEL"
            label="联系电话"
            width="115"
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="pane HouseList" v-show="houseListShow">
      <h3>
        <span>{{ schoolName }}</span
        >覆盖楼盘<i>{{ housenum }}</i
        >个
        <i class="el-icon-close" @click="closeHouseList"></i>
      </h3>
      <div class="cont">
        <span
          class="houseItem"
          v-for="item in schoolHouses"
          :key="item.index"
          @click="showHouseInMap(item)"
          >{{ item }}</span
        >
      </div>
    </div>

    <!-- ai弹窗界面 -->
    <div class="pane AIContent" v-show="showPopAI">
      <h3>
        <span>{{ nameAI }}</span>
        <i class="el-icon-close" @click="closeAIPop"></i>
      </h3>
      <div class="cont" v-loading="aiLoading">
        <p style="margin-bottom: 10px">
          以下内容为AI检索结果，仅供参考。家长在决策时请务必结合官方文件进行核实。
        </p>
        <p v-html="areaContentAI"></p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "schoolPane",
  data() {
    return {
      loading: true,
      areaValue: "长沙市",
      schoolHouses: [],
      shcoolnum: "",
      housenum: "",
      schoolName: "",
      houseListShow: false,
      tableDataItem: {
        num: "",
        name: "",
        phone: "",
      },
      tableData: [],
      // ai弹窗配置内容
      showPopAI: false,
      areaContentAI: "",
      nameAI: "",
      aiLoading: false,
    };
  },
  methods: {
    // 关闭ai弹窗
    closeAIPop() {
      this.showPopAI = false;
      this.areaContentAI = "";
      this.nameAI = "";
      this.aiLoading = false;
    },
    // 打开弹窗
    openAIpop(nameValue) {
      this.aiLoading = true;
      this.showPopAI = true;
      // 创建 AbortController 实例
      const controller = new AbortController();
      const signal = controller.signal;
      // console.log('%c [ nameValue ]-102', 'font-size:13px; background:pink; color:#bf2c9f;', nameValue)
      // if(this.nameAI != nameValue){
      //   controller.abort()
      // }
      let value = "";
      if (nameValue.includes("学区")) {
        value = nameValue.replace(/学区/g, "");
      } else {
        value = nameValue;
      }
      this.nameAI = value.length > 14 ? `${value.slice(0, 14)}...` : value;
      const that = this;
      // const timeId = setTimeout(() => {
      //   let vanOverlay = document.querySelector(".van-overlay");
      //   if (vanOverlay) {
      //     vanOverlay.addEventListener("click", () => {
      //       controller.abort();
      //     });
      //   }
      // }, 100);
      // this.$toast.loading({
      //   message: "加载中...",
      //   overlay: true,
      //   // forbidClick: true,
      //   // closeOnClickOverlay:true,
      //   duration: 0,
      //   onClose: () => {
      //     // flag = true
      //     // that.$toast.clear();
      //   },
      // });
      // 要发送的数据
      const data = {
        // content: `请介绍湖南省${value}的基本信息、办学理念、教学特色、师资力量、校园环境、学生活动、荣誉成就、历史沿革、课程设置以及校园文化,并以html结构返回，大标题用h2,小标题用h3,其他内容用p标签,p标签字体号用14px`,
        // content: `请介绍湖南省${value}的基本信息、办学理念、教学特色、师资力量、校园环境、学生活动、荣誉成就、历史沿革、课程设置以及校园文化,以上请参考官方的真实数据。其中，大标题用h2,小标题用h3,其他内容用p标签,p标签字体号用14px`,
        content: `请以基本信息、办学理念、教学特色、师资力量、校园环境、学生活动、荣誉成就、历史沿革、课程设置以及校园文化为标题分别介绍湖南省${value}。并以html结果返回。其中，大标题用h2,小标题用h3,其他内容用p标签,p标签字体号用14px`,
        systemPrompt: "",
        model: "Qianfan-Agent-Speed-8k",
        serviceName: "Qianfan",
      };

      // 配置请求选项
      const config = {
        // headers: {
        //   // 通常使用 Authorization 字段传递 token
        //   // Authorization: `Bearer sk-171fdcfc46bf431692ffa7a4da3ac5ac`,
        //   Authorization: `714caa2a22bf41fab74a8e95bd0fe4a6.PeoNkcZjX9gcYkU1`,
        // },
        signal,
        headers:{
          'api-access-token':that.$store.state.globalParams.AIToken
        }
      };
      // .post("https://api.deepseek.com/chat/completions", data, config)
      axios
        .post(
          "https://hunan.tianditu.gov.cn/api/ai/chat/v1",
          data,
          config
        )
        .then((res) => {
          // clearTimeout(timeId);
          console.log(res.data, "结果");
          if (res.data.success == true) {
            // console.log('%c [ that.isTrigger ]-363', 'font-size:13px; background:pink; color:#bf2c9f;', that.isTrigger)
            // if (that.isTrigger) {
            // that.$toast.clear();
            that.aiLoading = false;
            that.showPopAI = true;
            // that.areaContentAI = res.data.choices[0].message.content;
            let con = res.data.content;
            that.areaContentAI = con.slice(7);
            // that.isTrigger = false;
            // }
          }
        })
        .catch((error) => {
          that.aiLoading = false;
          // if (error.name === "AbortError") {
          //   // console.log("请求已取消");
          //   that.$toast.clear()
          // } else {
          //   // console.log("请求出错:", error);
          // }
          // that.$toast.clear();
          // clearTimeout(timeId);
        });
    },
    showLoading() {
      this.loading = true;
    },
    //加载表格数据
    showTableData(data) {
      this.tableData = data;
      this.shcoolnum = data.length;
      this.loading = false;
    },
    // 更改区域名
    changeAreaValue(data) {
      this.areaValue = data;
      //关闭下方小区弹窗
      this.houseListShow = false;
    },
    // 点击学校列表后执行的函数
    showSchoolHouse(value) {
      console.log(value);
      this.schoolHouses = [];
      this.$parent.showMyChooseSchool(value);
    },
    // 改变学校名显示
    changeSchoolNameShow(data) {
      if (data.length > 5) {
        this.schoolName = data.substring(0, 5) + "...";
      } else {
        this.schoolName = data;
      }
    },
    // 从搜索列表过来的为了显示学校小区的函数
    showSchoolHouseBySearch(value) {
      this.houseListShow = true;
      this.schoolHouses = [];
      console.log(value);
      for (let i = 0; i < value.length; i++) {
        this.schoolHouses.push(value[i].properties.XIAOQU);
      }
      this.housenum = value.length;
    },
    // 点击小区列表执行的函数
    showHouseInMap(data) {
      this.$parent.showMyChooseHouse(data);
    },
    closeHouseList() {
      this.houseListShow = false;
      this.$parent.removeAllLayer();
    },
    //打开温馨提示
    openInfo() {
      this.$alert(
        '<p class="infoP">一、公办小学学区划分由教育行政管理部门负责，有关学区划分问题以教育行政管理部门解释为准。长沙县、浏阳市、宁乡市学区划分数据在当地教育行政管理部门公布后更新。</p><p class="infoP">二、对公办义务教育学校学区划分及入学政策有疑问的，请咨询芙蓉区教育局基础教育科(电话84683247)、天心区教育局基础教育科（电话81830202)、湘江新区管理委员会教育局基础教育处（电话88999272）、开福区教育局基础教育处(电话82528880)、雨花区教育局基础教育处 (电话85880323） 、望城区教育局普职教育科(电话88063641） 以及长沙市教育局基础教育处（电话84899710)。</p><p class="infoP">三、行业办子弟小学资产为国有性质，子弟小学主要招收其举办单位职工子女。</p>',
        "温馨提示",
        {
          dangerouslyUseHTMLString: true,
        }
      );
    },
  },
};
</script>

<style scoped lang="scss">
* {
  margin: 0;
  padding: 0;
}
.pane {
  width: 350px;
  box-sizing: border-box;
  box-shadow: 1px 1px 5px rgb(0 0 0 / 30%);
  background: #fff;
  position: fixed;
  border-radius: 5px;
  z-index: 20001;
  right: 20px;
  padding: 10px;
  h3 {
    line-height: 45px;
    padding: 0;
    margin: 0;
    font-weight: normal;
    padding-left: 20px;
    font-size: 18px;
    position: relative;
    span {
      font-weight: bold;
      margin-right: 5px;
      color: #409eff;
      font-size: 20px;
    }
    i {
      font-weight: bold;
      margin: 0 5px;
      color: #e6a23c;
      font-size: 22px;
    }
    &:after {
      content: "";
      height: 25px;
      width: 8px;
      background-color: #409eff;
      top: 10px;
      left: 0;
      z-index: 2;
      position: absolute;
    }
    .info2 {
      width: 20px;
      height: 20px;
      position: absolute;
      right: 10px;
      top: 13px;
      z-index: 3;
      border-radius: 20px;
      img {
        display: block;
        width: 20px;
        height: 20px;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 11;
      }
      .circle1,
      .circle2,
      .circle3 {
        width: 20px;
        height: 20px;
        box-sizing: border-box;
        background: rgba(230, 162, 60, 0.75);
        border: 1px solid rgba(230, 162, 60, 0.85);
        border-radius: 99px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        animation-name: circleChange;
        animation-duration: 3s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
      }
      .circle1 {
        animation-delay: 1s;
      }
      .circle2 {
        animation-delay: 2s;
      }
      .circle3 {
        animation-delay: 3s;
      }
    }
  }
  .cont {
    position: absolute;
    top: 60px;
    left: 10px;
    right: 10px;
    bottom: 10px;
    z-index: 2;
    overflow: hidden;
    overflow-y: auto;
    .el-table {
      font-size: 13px;
    }
    .houseItem {
      display: inline-block;
      padding: 4px 10px;
      margin: 0 8px 8px 0;
      background-color: #409eff;
      color: #fff;
      border-radius: 5px;
      font-size: 13px;
    }
  }
}

@keyframes circleChange {
  0% {
    transform: scale(1);
    opacity: 0.95;
  }
  25% {
    transform: scale(1.4);
    opacity: 0.75;
  }
  50% {
    transform: scale(1.6);
    opacity: 0.5;
  }
  75% {
    transform: scale(1.8);
    opacity: 0.25;
  }
  100% {
    transform: scale(2);
    opacity: 0.05;
  }
}

.SchoolList {
  height: 63%;
  top: 3%;
}
.HouseList {
  top: 69%;
  height: 28%;
  .el-icon-close {
    position: absolute;
    right: 0px;
    top: 12px;
    z-index: 3;
    color: #2c3e50;
  }
}
.AIContent {
  top: 3%;
  right: 19.5%;
  height: 30%;
  .el-icon-close {
    position: absolute;
    right: 0px;
    top: 12px;
    z-index: 3;
    color: #2c3e50;
  }
  p {
    line-height: 1.5;
    padding: 0;
    margin: 0;
  }
}

@media screen and (max-width: 767px) {
  .SchoolList {
    display: none;
  }
  .HouseList {
    top: 110px;
    left: 5px;
    height: 180px;
    width: calc(100% - 10px);
    h3 {
      line-height: 35px;
      font-size: 14px;
      span {
        font-size: 16px;
      }
      i {
        font-size: 18px;
      }
      &:after {
        height: 20px;
        top: 6px;
      }
      .el-icon-close {
        top: 8px;
        right: 0px;
      }
    }
  }
  .AIContent {
    top: 295px;
    left: 5px;
    height: 180px;
    width: calc(100% - 10px);
    h3 {
      line-height: 35px;
      font-size: 14px;
      span {
        font-size: 16px;
      }
      i {
        font-size: 18px;
      }
      &:after {
        height: 20px;
        top: 6px;
      }
      .el-icon-close {
        top: 8px;
        right: 0px;
      }
    }
    p {
      line-height: 1.5;
      padding: 0;
      margin: 0;
    }
  }
}
</style>
